import {ContentSubmission} from '@/types/contentSubmission';

// Max submittedAt (an alias of created_at) across versions, matching the
// backend's MAX(created_at) sort. Null when no version has one.
function getLatestVersionUploadDate(cs: ContentSubmission): string | null {
  const versions = cs.versions ?? [];

  return versions.reduce<string | null>((latest, version) => {
    const {submittedAt} = version;
    if (!submittedAt) {
      return latest;
    }
    if (latest === null || new Date(submittedAt) > new Date(latest)) {
      return submittedAt;
    }
    return latest;
  }, null);
}

export default getLatestVersionUploadDate;
